import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScansListItem } from "../../../types";

const ScansTableLabelsCell = ({
  item: scan,
  ...cellProps
}: TableSimpleCellProps<ScansListItem>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={scan.labels} />
    </TableSimpleCell>
  );
};

export default ScansTableLabelsCell;
